import React from "react";
import FooterArabic from "./PrintArabic/Footer";
import BodyArabic from "./PrintArabic/body";

const PrintArabic = () => {
    return (
        <div>
            <BodyArabic />
            <br />
            <br />
            <FooterArabic />
        </div>
    );
};

export default PrintArabic;
